import { memo } from 'react';
import { Outlet } from 'react-router-dom';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import TrialGuard from '@/components/TrialGuard';
import { Layout } from './Layout';

/**
 * ProtectedLayout wraps all authenticated routes with:
 * 1. ProtectedRoute (auth guard)
 * 2. TrialGuard (subscription guard)
 * 3. Layout (sidebar, header, bottom nav)
 * 
 * Uses React Router nested routes via <Outlet />.
 */
export const ProtectedLayout = memo(() => (
  <ProtectedRoute>
    <TrialGuard>
      <Layout>
        <Outlet />
      </Layout>
    </TrialGuard>
  </ProtectedRoute>
));

ProtectedLayout.displayName = 'ProtectedLayout';

/**
 * AdminProtectedLayout adds AdminRoute guard on top of ProtectedLayout.
 */
export { ProtectedLayout as default };
